import { render, staticRenderFns } from "./SettingsCreateLanguage.vue?vue&type=template&id=4fb7f8a4&scoped=true"
import script from "./SettingsCreateLanguage.vue?vue&type=script&lang=js"
export * from "./SettingsCreateLanguage.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateLanguage.vue?vue&type=style&index=0&id=4fb7f8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7f8a4",
  null
  
)

export default component.exports